/**
 * @author ESTECO CSA Team <csa@esteco.com>
 */
export enum GridDensity {
    FULL = 'l-grid--full',
    NARROW = 'l-grid--narrow',
    WIDE = 'l-grid--wide'
}
